import { useState } from "react";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AccountSettings() {
  const { user } = useAuth();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [saving, setSaving] = useState(false);

  const save = async () => {
    if (pw.length < 6) { toast.error("Şifre en az 6 karakter olmalı"); return; }
    if (pw !== pw2) { toast.error("Şifreler eşleşmiyor"); return; }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { new_password: pw });
      toast.success("Şifreniz güncellendi");
      setPw(""); setPw2("");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Şifre güncellenemedi");
    } finally { setSaving(false); }
  };

  return (
    <div className="max-w-lg" data-testid="account-settings">
      <h1 className="font-heading text-2xl font-bold text-[#26231E] mb-1">Hesap Ayarları</h1>
      <p className="text-sm text-[#8C8377] mb-6">Giriş şifrenizi buradan güncelleyebilirsiniz.</p>

      <div className="bg-white border border-[#E7DECC] rounded-sm p-6 space-y-4">
        <div className="flex flex-wrap gap-6 text-sm pb-4 border-b border-[#E7DECC]">
          <div><span className="text-[#8C8377]">Ad: </span><b>{user?.name}</b></div>
          <div><span className="text-[#8C8377]">E-posta: </span><b>{user?.email}</b></div>
        </div>
        <div>
          <label className="kicker block mb-1">YENİ ŞİFRE</label>
          <input type="password" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="account-new-password"
            className="w-full px-3 py-2 border border-[#E7DECC] rounded-sm text-sm focus:outline-none focus:border-[#B8933F]" placeholder="En az 6 karakter" />
        </div>
        <div>
          <label className="kicker block mb-1">YENİ ŞİFRE (TEKRAR)</label>
          <input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="account-new-password2"
            className="w-full px-3 py-2 border border-[#E7DECC] rounded-sm text-sm focus:outline-none focus:border-[#B8933F]" placeholder="Şifreyi tekrar girin" />
        </div>
        <button onClick={save} disabled={saving} data-testid="account-save-password"
          className="flex items-center gap-1.5 px-4 py-2 bg-[#B8933F] hover:bg-[#9C7A33] text-white rounded-sm text-sm font-medium transition-colors duration-150 disabled:opacity-50">
          <KeyRound className="w-4 h-4" /> {saving ? "Kaydediliyor…" : "Şifreyi Güncelle"}
        </button>
      </div>
    </div>
  );
}
